export default __webpack_public_path__ + "static/media/BackIcon.73b6982b.svg";